import React from 'react';
import { handleEventInfoData } from "../../utils/storeConverter";
import { fireActionTriggerCustomEvent } from "../../utils/adobe-launch";
import { Link } from 'react-router-dom';
import './MyHero.css';

import courtneyHero from '../../assets/hero/hero-img.png';

const myHero = (props) => {
  
  return (
  <div className="MainContainer">
    <div className="MiddleContainer">
      <div className="InnerContainer">
        <img className="HeroImage" src={courtneyHero} alt="Courtney 1986 at the Arcade" />
        <Link className="HeroButton" onClick={(e) =>{ 
          props.changeEnterMall(false);
          handleEventInfoData({
            storeName: window.digitalData.pageInfo.page_name,
            page_name:
              window.digitalData.pageInfo.page_name + `:enter mall`,
            location_name: `courtney mall entrance`,
          });
          console.log("[next click event] ", window.digitalData);
          fireActionTriggerCustomEvent(
            e.target,
            window.digitalData.event
          );
        }} 
        to="/store/1">Enter Mall</Link>
      </div>
    </div>
  </div>
)};

export default myHero;